export default
{
    props:
    {
        youtubeID: {
            type: String
        }
    }
}
